// extracted by mini-css-extract-plugin
export default {"Container":"UserChip_Container__Lrinl","Label":"UserChip_Label__PTa88","Name":"UserChip_Name__PreMR","CloseIcon":"UserChip_CloseIcon__WSYbT","Text":"UserChip_Text__bUZXt"};